__turbopack_context__.v({
  "helios-container": "JUMTkG_helios-container",
  "helios-container--gutters-compact": "JUMTkG_helios-container--gutters-compact",
  "helios-container--gutters-default": "JUMTkG_helios-container--gutters-default",
  "helios-container--gutters-editorial": "JUMTkG_helios-container--gutters-editorial",
  "helios-container--gutters-md": "JUMTkG_helios-container--gutters-md",
  "helios-container--gutters-none": "JUMTkG_helios-container--gutters-none",
  "helios-container--width-default": "JUMTkG_helios-container--width-default",
  "helios-container--width-full": "JUMTkG_helios-container--width-full",
  "helios-container--width-md": "JUMTkG_helios-container--width-md",
  "helios-container--width-panel": "JUMTkG_helios-container--width-panel",
  "helios-container--width-sm": "JUMTkG_helios-container--width-sm",
  "helios-container--width-wide": "JUMTkG_helios-container--width-wide",
});
